// @ts-strict-ignore
import React, { forwardRef, useEffect, useState, useRef } from 'react'
import useScrollbarSize from 'react-scrollbar-size'
import { Content as LibraryContent } from '@mytours/components'
import type { ContentProps } from '@mytours/components'
import { isIOSDevice } from 'mobile_web/modules/platform/device'

import './styles.less'

// Ionic's content as it was configured here: the main landmark, rubber-banding on iOS.
export const ScrollContent = forwardRef<HTMLDivElement, ContentProps>(function ScrollContent(props, ref) {
	return <LibraryContent ref={ref} main forceOverscroll={isIOSDevice()} {...props} />
})

const Content = props => {
	const contentRef = useRef<HTMLDivElement>()
	const [scrollbarWidth, setScrollbarWidth] = useState<number>()
	const { width } = useScrollbarSize()

	const isScrollable = (element: HTMLDivElement): boolean => {
		const y1 = element.scrollTop
		element.scrollTop += 1
		const y2 = element.scrollTop
		element.scrollTop -= 1
		const y3 = element.scrollTop
		element.scrollTop = y1

		return y1 !== y2 || y2 !== y3
	}

	useEffect(() => {
		if (width && contentRef?.current && isScrollable(contentRef.current)) {
			setScrollbarWidth(width)
		} else {
			setScrollbarWidth(0)
		}
	}, [width, contentRef])

	useEffect(() => {
		if (scrollbarWidth || scrollbarWidth === 0) {
			document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
		}
	}, [scrollbarWidth])

	return (
		<ScrollContent {...props}>
			<div className="container">{props.children}</div>
		</ScrollContent>
	)
}

export default Content
